import React, {useEffect, useState} from "react";
import * as Sentry from '@sentry/browser';
import {FormattedMessage} from "react-intl";
import {NavLink} from "react-router-dom";
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import TableRow from "./TableRow";
import Loader from "../Utils/Loader";
import Empty from "./Empty";
import classes from "./styles.module.css";

function renderStatus(data) {
    if (!data || data.status === undefined) return <div className={classes.Disabled}><FormattedMessage
        id="PrepaidTable.status.inactive" defaultMessage="Не активна"/></div>;
    switch (data.status) {
        case 0:
            return <div className={classes.Disabled}><FormattedMessage id="PrepaidTable.status.inactive"
                                                                       defaultMessage="Не активна"/></div>;
        case 1:
            return <div className={classes.Process}><FormattedMessage id="PrepaidTable.status.processing"
                                                                      defaultMessage="Обрабатывается"/></div>;
        case 2:
            return <div className={classes.Enables}><FormattedMessage id="PrepaidTable.status.active"
                                                                      defaultMessage="Активна"/></div>;
        case 3:
            return <div className={classes.Error}><FormattedMessage id="PrepaidTable.status.error"
                                                                    defaultMessage="Ошибка"/></div>;
        default:
            return <div className={classes.Disabled}><FormattedMessage id="PrepaidTable.status.inactive"
                                                                       defaultMessage="Не активна"/></div>;
    }
}

function PrepaidMobileCard({data}) {
    const safeData = data || {};
    const cardPart = safeData.part ? safeData.part.replace(/[*]{6}/g, " •••• ") : "";
    const canActivate = safeData.status === 0 || safeData.status === 3;

    return (
        <div className={classes.MobileCard}>
            <div className={classes.MobileCardHeader}>
                <div className={classes.MobileCardTitle}>
                    <span className={classes.MobileLabel}>
                        <FormattedMessage id="PrepaidTable.table.ean" defaultMessage="EAN"/>
                    </span>
                    <span className={classes.MobileEan}>{safeData.ean || "-"}</span>
                </div>
                <div className={classes.MobileStatus}>{renderStatus(safeData)}</div>
            </div>

            <div className={classes.MobileFields}>
                <div className={classes.MobileField}>
                    <span className={classes.MobileLabel}>
                        <FormattedMessage id="PrepaidTable.table.card" defaultMessage="Карта"/>
                    </span>
                    <span className={classes.MobileValue}>{cardPart || "-"}</span>
                </div>
                <div className={classes.MobileField}>
                    <span className={classes.MobileLabel}>
                        <FormattedMessage id="PrepaidTable.table.project" defaultMessage="Проект"/>
                    </span>
                    <span className={classes.MobileValue}>{safeData.merchantName || "-"}</span>
                </div>
                <div className={classes.MobileField}>
                    <span className={classes.MobileLabel}>
                        <FormattedMessage id="PrepaidTable.table.client" defaultMessage="Клиент"/>
                    </span>
                    <span className={classes.MobileValue}>{safeData.fio || "—"}</span>
                </div>
            </div>

            <div className={classes.MobileActions}>
                <NavLink className={classes.MobileDetailsLink} to={`/prepaid/details/${safeData.ean || ""}`}>
                    <FormattedMessage id="PrepaidTable.menu.details" defaultMessage="Детализация"/>
                </NavLink>
                {canActivate && (
                    <NavLink className={classes.MobileActivateLink} to={`/prepaid/activate/${safeData.ean || ""}`}>
                    <FormattedMessage id="PrepaidTable.menu.activate" defaultMessage="Активация"/>
                    </NavLink>
                )}
            </div>
        </div>
    );
}

function PrepaidTable({token}) {
    const [cardList, setCardList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        new Api({token})
            .getPreActivatedCardsList()
            .then((r) => {
                setCardList(r || []);
                setLoading(false);
            })
            .catch((err) => { Sentry.captureException(err); setLoading(false); });
    }, [token]);

    return loading ? (
        <Loader/>
    ) : (
        <React.Fragment>
            <table className={classes.Table}>
                <thead>
                <tr>
                    <th><FormattedMessage id="PrepaidTable.table.ean" defaultMessage="EAN"/></th>
                    <th><FormattedMessage id="PrepaidTable.table.card" defaultMessage="Карта"/></th>
                    <th><FormattedMessage id="PrepaidTable.table.project" defaultMessage="Проект"/></th>
                    <th><FormattedMessage id="PrepaidTable.table.client" defaultMessage="Клиент"/></th>
                    <th><FormattedMessage id="PrepaidTable.table.status" defaultMessage="Статус"/></th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {!loading && cardList && cardList.length > 0 ? (
                    cardList.map((el, i) => <TableRow key={i} data={el}/>)
                ) : (
                    <Empty/>
                )}
                </tbody>
            </table>

            <div className={classes.MobileList}>
                {cardList && cardList.length > 0 ? (
                    cardList.map((el, i) => <PrepaidMobileCard key={(el && el.ean) || i} data={el}/>)
                ) : (
                    <div className={classes.MobileEmpty}>
                        <FormattedMessage id="PrepaidTable.empty" defaultMessage="Нет предоплаченных карт"/>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default withAuth(PrepaidTable);



// WEBPACK FOOTER //
// ./src/Components/PrepaidTable/index.js